import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, ValidatorFn, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HeaderService } from '../header/service/header.service';
import { ModalEsqueceuSenhaComponent } from '../shared/components/modais/modal-esqueceu-senha/modal-esqueceu-senha.component';
import { AuthService } from '../shared/services/auth/auth.service';

function noLeadingSpaces(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    if (value && typeof value === 'string' && value.startsWith(' ')) {
      return { leadingSpaces: true };
    }
    return null;
  };
}

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, HttpClientModule, ModalEsqueceuSenhaComponent],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  loginForm: FormGroup;
  isLoading = false;
  errorMessage = '';
  showPassword = false;
  showForgotModal = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private headerService: HeaderService
  ) {

    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
    }

    this.loginForm = this.fb.group({
      login:    ['', [Validators.required, noLeadingSpaces()]],
      password: ['', [Validators.required]]
    });
  }

  get loginControl()    { return this.loginForm.get('login'); }
  get passwordControl() { return this.loginForm.get('password'); }

  togglePassword() { this.showPassword = !this.showPassword; }
  openForgotModal()  { this.showForgotModal = true; }
  closeForgotModal() { this.showForgotModal = false; }

  ngOnInit(): void {
  this.loadMerlinWidget();
  this.hideMovidesk();
}

  private loadMerlinWidget(): void {
  if (document.getElementById('merlin-widget-script')) {
    return;
  }
 
  const script = document.createElement('script');
  script.id = 'merlin-widget-script';
  script.src = 'https://scripts.gomerlin.com.br/merlin.js';
  script.defer = true;
 
  script.onload = () => {
    try {
      (window as any).Merlin?.Popup?.initFromSource(
        'https://tools.gomerlin.com.br/popup/294365f1-1540-44a8-8234-411c0578a81b'
      );
    } catch (err) {
      console.warn('Merlin widget não inicializou:', err);
    }
  };
 
  document.body.appendChild(script);
  }
 
  ngOnDestroy(): void {
    const script = document.getElementById('merlin-widget-script');
    script?.remove();
    document.querySelectorAll('[class*="merlin-"]').forEach(el => el.remove());
    
    this.showMovidesk();
  }

  private hideMovidesk(): void {
    const style = document.createElement('style');
    style.id = 'hide-movidesk-style';
    style.innerHTML = `
      #md-app-widget,
      [id^="movidesk"],
      .md-chat-widget {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  private showMovidesk(): void {
    document.getElementById('hide-movidesk-style')?.remove();
  }
  onSubmit() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    const payload = {
      login:    this.loginForm.value.login,
      password: this.loginForm.value.password
    };

   this.headerService.authorization(payload).subscribe({
  next: (response) => {
    this.isLoading = false;
 
    if (response?.data?.token) {
      this.authService.saveLoginData(response.data.token, response.data.restrictionKey ?? '');
 
      const redirectUrl = this.authService.getAndClearRedirectUrl();

      this.router.navigateByUrl(redirectUrl);
    } else {
      this.errorMessage = response?.message || 'Login ou senha inválidos.';
    }
  },
      error: (err) => {
        this.isLoading = false;
        if (err.status === 401 || err.status === 400) {
          this.errorMessage = 'Login ou senha inválidos.';
        } else if (err.status === 403) {
          this.errorMessage = err.error?.message || 'Conta bloqueada. Verifique seu e-mail.';
        } else if (err.status === 429) {
          this.errorMessage = 'Acesso bloqueado por excesso de tentativas. Tente novamente mais tarde.';
        } else {
          this.errorMessage = 'Não foi possível conectar ao servidor. Tente novamente.';
        }
      }
    });
  }
}